module.exports = __webpack_public_path__ + "gs.06d0809b64f459da2e29.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gs.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gs.svg
// module chunks = styles